import React, { PureComponent } from 'react'
import { Row, Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import TaskListPage from '../../containers/dashboard/taskList/TaskListPage'
import { styleTasks } from '../../constants/backendIds'
import TrackingContainer from '../../containers/tracking/trackingContainer'
import { CustomDimensionsConstant } from '../../constants/tracking/CustomDimensionsConstant'
import { TrackingActions } from '../../constants/tracking/TrackingActions'
import { TrackedPages } from '../../constants/tracking/TrackedPages'
import settings from '../../settings/settings'
// import {urgencyTypesId} from '../../constants/backendIds'
// import styleTasks from '../../constants/backendIds'

class DashboardTasks extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: true
    }
  }

  onSelectUrgencyTaskGroupTab (urgencyType) {
    this.props.actions.fetchFilteredDashboardTask(this.props.activeTaskDescription, urgencyType, this.props.activeTaskId)
  }

  onSelectTaskGroupItem (taskGroupKey, taskDescription) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    this.props.actions.fetchFilteredDashboardTask(taskDescription, this.props.urgencyType, taskGroupKey)
    this.props.trackAction(this.factoryDashBoardTask(taskGroupKey, taskDescription))
  }

  factoryDashBoardTask (activeTaskid, activeTaskDescription) {
    return {
      href: window.location.href,
      action: TrackingActions.LOAD_DASHBOADTASK,
      documentTitle: TrackedPages.DASHBOAD_TASK,
      category: TrackedPages.DASHBOAD_TASK,
      customDimensions: [
        {
          id: CustomDimensionsConstant.DASHBOARD_TASK_ID,
          value: activeTaskid || this.props.activeTaskId
        },
        {
          id: CustomDimensionsConstant.DASHBOARD_TASK_NAME,
          value: activeTaskDescription || this.props.activeTaskDescription
        }
      ]
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.organizedUnit && this.props.organizedUnit !== prevProps.organizedUnit) {
      if (this.props.activeTaskId) {
        this.props.actions.fetchFilteredDashboardTask(this.props.activeTaskDescription,
          this.props.urgencyType,
          this.props.activeTaskId)
      } else {
        this.props.actions.fetchDashboardTask()
      }
    }
  }

  componentDidMount () {
    this.props.trackVisitPage({
      documentTitle: TrackedPages.DASHBOAD_TASK,
      href: window.location.href
    })
    return new Promise((resolve, reject) => {
      this.reloadTaskDashboard(resolve, reject)
    }).then(() => {
      this.setState({ isLoading: false })
    })
  }

  reloadTaskDashboard (resolve, reject) {
    if (settings.reloadTaskDashboardOnReturn || !this.props.activeTaskId) {
      this.props.actions.fetchDashboardTask(resolve, reject)
    }

    if (this.props.activeTaskId) {
      this.props.actions.fetchFilteredDashboardTask(
        this.props.activeTaskDescription,
        this.props.urgencyType,
        this.props.activeTaskId
      )
    }
  }

  applyStyleTask (task, activeTaskId) {
    switch (task.styleCss) {
      case styleTasks.Bold:
        return 'activebold'
      case styleTasks.BoldBlue:
        return 'activeboldblue'
      case styleTasks.BoldRed:
        return 'activeboldred'
      default:
        if (task.taskId === activeTaskId) {
          return 'active'
        } else {
          return ''
        }
    }
  }

  render () {
    const {
      t,
      tasks,
      // urgencyType,
      activeTaskId
    } = this.props
    const tKey = 'DASHBOARD_TASK.'
    const taskTextTooltip = (taskTextTooltip) => (<Tooltip id="editTooltip">{taskTextTooltip}</Tooltip>)

    if (!tasks.taskList.length) {
      return (
        <div className="dashboard-tasks-wrapper">
          <Button onClick={() => this.props.actions.fetchDashboardTask()} id="BUTTON_REFRESH_TASK_LIST">{t(tKey + 'REFRESH_TASK_LIST')}</Button>
          <h4>{`${t(tKey + (this.state.isLoading ? 'SEARCHING_MESSAGE' : 'INFO_MESSAGE'))}`}</h4>
        </div>
      )
    } else {
      return (
        <div className="dashboard-tasks-wrapper">
          <Button onClick={() => this.props.actions.fetchDashboardTask()} id="BUTTON_REFRESH_TASK_LIST">{t(tKey + 'REFRESH_TASK_LIST')}</Button>
          {/* <div className="dashboard-tasks-header">
            <ul className="list-inline">
              <li
                className={'turquoise ' + (!urgencyType || urgencyType === urgencyTypesId.todas ? 'active' : '')}
                onClick={this.onSelectUrgencyTaskGroupTab.bind(this, urgencyTypesId.todas)}
              >
                {`${t(`${tKey}URGENCY_TYPES.TODAS`)}`} <Label bsStyle="info">{tasks.totalTasks}</Label>
              </li>
              <li
                className={'gray ' + (urgencyType === urgencyTypesId.ontime ? 'active' : '')}
                onClick={this.onSelectUrgencyTaskGroupTab.bind(this, urgencyTypesId.ontime)}
              >
                {`${t(`${tKey}URGENCY_TYPES.ON_TIME`)}`} <Label bsStyle="default">{tasks.totalOnTime}</Label>
              </li>
              <li
                className={'red ' + (urgencyType === urgencyTypesId.high ? 'active' : '')}
                onClick={this.onSelectUrgencyTaskGroupTab.bind(this, urgencyTypesId.high)}
              >
                {`${t(`${tKey}URGENCY_TYPES.ROJOS`)}`} <Label bsStyle="danger">{tasks.totalUrgency}</Label>
              </li>
            </ul>
          </div> */}
          <div className="dashboard-tasks-body">
            <Row>
              <Col sm={3} className="dashboard-tasks-panel-left">
                <ul className="list">
                  {
                    tasks.taskList.map((item, idx) => {
                      return (
                        <li
                          onClick={this.onSelectTaskGroupItem.bind(this, item.taskId, item.taskDescription)}
                          className={this.applyStyleTask(item, activeTaskId)}
                          key={idx}
                        >
                          <OverlayTrigger key={idx} trigger={['hover', 'focus']} placement="right" overlay={taskTextTooltip(item.taskTextTooltip)}>
                            <span>
                              {item.taskDescription}
                              {/* &nbsp;
                              <small>({item.totalItems})</small>
                              &nbsp;
                              {item.hasUrgency && (
                                <span className="color-point red"/>
                              )} */}
                            </span>
                          </OverlayTrigger>
                        </li>
                      )
                    })
                  }
                </ul>
              </Col>
              <Col sm={9} className="dashboard-tasks-panel-righ-container">
                <TaskListPage history={this.props.history}/>
              </Col>
            </Row>
          </div>
        </div>
      )
    }
  }
}
var decoratedComponent = TrackingContainer(DashboardTasks, false)
export default decoratedComponent
